


































import { Component, Prop, Vue } from 'vue-property-decorator';
import Warning from '@/components/page/Warning.vue';
import { WorkScope } from '@/api/com/MetaPattern/MDA/MD/Base/WorkScope';
import WorkScopeEdit from '@/components/MDA/MD/WorkScopeEdit.vue';
import { BaseService } from '@/api/com/MetaPattern/MDA/MD/Base/BaseService';
import { EnumPersistenceStatus } from '@/api/com/MetaPattern/Core/Infrastructure/Common/EnumPersistenceStatus';
import { Product } from '@/api/com/MetaPattern/MDA/MD/Base/Product';
import { APP } from '@/api/com/MetaPattern/MDA/MD/Base/APP';

@Component({
  components: {
    Warning,
    WorkScopeEdit
  }
})
export default class WorkScopeList extends Vue {
  private showEdit = false;
  private curWorkScope: WorkScope;
  private key = 0;

  constructor() {
    super();
    this.showEdit = false;
    this.curWorkScope = null;
  }

  get tableData() {
    return this.$store.state.ModuleMD.workScopes;
  }

  createRow() {
    this.key++;
    this.curWorkScope = null;
    this.showEdit = true;
  }

  editRow(row: WorkScope) {
    this.key++;
    this.curWorkScope = row;
    this.showEdit = true;
  }

  canDelete(workScope: WorkScope) {
    const findApp = this.$store.state.ModuleMD.apps.find((app: APP) => app.workScope_ID === workScope.id);
    if (findApp) {
      return false;
    }
    const findProduct = this.$store.state.ModuleMD.products.find((product: Product) => product.workScope_ID === workScope.id);
    if (findProduct) {
      return false;
    }
    return true;
  }

  deleteRow(row: WorkScope) {
    this.$confirm('您确定要删除工作空间么？删除以后不可恢复。', '删除提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      BaseService.DeleteWorkScopeAsync(row.id)
        .then(() => {
          const workScopes = this.$store.state.ModuleMD.workScopes;
          const index = workScopes.findIndex((item: WorkScope) => item.designId === row.designId);
          if (index >= 0) {
            workScopes.splice(index, 1);
          }
          this.$message({ type: 'success', message: '删除成功!' });
        })
        .catch((err) => {
          this.$message({ type: 'error', message: err });
        });
    }).catch(() => {
      // 取消删除
    });
  }

  closeEdit(entity: WorkScope) {
    this.showEdit = false;
    if (entity !== null) {
      const findWorkScope = this.$store.state.ModuleMD.workScopes.find((item: WorkScope) => item.designId === entity.designId) as WorkScope;
      if (findWorkScope) {
        findWorkScope.copyFrom(entity, false);
      } else {
        this.$store.state.ModuleMD.workScopes.push(entity);
      }
    }
  }
}

